import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			height: 'auto',
			padding: theme.spacing(3),
			borderRadius: theme.spacing(3.2),
			boxShadow: 'none',
			marginTop: theme.spacing(1),
			marginRight: theme.spacing(1.5),
			marginLeft: theme.spacing(1.5),
			marginBottom: theme.spacing(5),

			[theme.breakpoints.down('xs')]: {
				marginRight: 0,
				marginLeft: 0,
			},
		},
		text: {
			marginBottom: theme.spacing(2),
		},
		starsWrap: {
			marginBottom: theme.spacing(2),
			lineHeight: 0,
		},

		person: {
			display: 'flex',
			alignItems: 'center',
		},

		personImage: {
			height: theme.spacing(7),
			width: theme.spacing(7),
			marginRight: theme.spacing(2),
			flexShrink: 0,

			'& img': {
				width: '100%',
				height: 'auto',
				objectFit: 'cover',
				objectPosition: 'center',
				transition: theme.transitions.create('border-radius'),
				borderRadius: ({ rounding }) => (rounding ? `${rounding}%` : null),
			},
		},

		personText: {
			flexGrow: 1,
			width: '100%',

			'& > *': {
				marginBottom: `0 !important`,
			},
		},
	}),
	{ name: 'Testimonials6-Cards-item' },
)

export default useStyles
